import styled, { css } from "styled-components";
import clsx from "clsx";

const InputField = ({
  label = '',
  className = '',
  value,
  min,
  max,
  step = 1,
  onBlur,
  onChange,
  ...rest 
}) => {
  return (
    <InputFieldLayout className={clsx("field-input", className)}>
      {label ? <span>{label}</span> : null}
      <input
        {...rest} 
        step={step}
        min={Math.round(min)}
        max={Math.round(max)}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
      />
    </InputFieldLayout>
  );
};

export default InputField;


const InputFieldLayout = styled.label`
  ${({ theme }) => css`
    span {
      margin-bottom: 10px;
      display: block;
    }
    input {
      width: 100%;
      border: 1px solid  ${theme.colors.gray[400]};
      border-radius: 30px;
      min-height: 30px;
      padding: 15px 20px;
      font-size: 16px;
      text-align: left;
    }
  `}
`;
